import React, { useState, useRef, useEffect } from 'react';
import { Spinner } from 'react-bootstrap';
import axios from 'axios';
import Constants from '../Constants';
import FormSection from './FormSection';
import '../App.css';

function VoiceSelector({ voice_id, voices, on_change, token }) {

	const [playing, set_playing] = useState(false);
	const [open, set_open] = useState(false);
	const [selected_name, set_selected_name] = useState('');
	const audio_ref = useRef(null);
	const dropdown_ref = useRef(null);

	useEffect(function() {
		if(voices.length > 0 && !voice_id) {
			on_change('voice_id', voices[0].voice_id);
		}
	}, [voices, voice_id]);

	useEffect(function() {
		if(voices.length > 0 && voice_id) {
			const found = voices.find(function(v) { return v.voice_id === voice_id; });
			if(found && found.name !== selected_name) {
				set_selected_name(found.name);
			}
		}
	}, [voice_id, voices]);

	useEffect(function() {
		const handle_click_outside = function(e) {
			if(dropdown_ref.current && !dropdown_ref.current.contains(e.target)) {
				set_open(false);
			}
		};
		document.addEventListener('mousedown', handle_click_outside);
		return function() {
			document.removeEventListener('mousedown', handle_click_outside);
		};
	}, []);

	const handle_play = async () => {
		if(!voice_id) return;
		set_playing(true);
		try {
			const headers = token ? { Authorization: 'Bearer ' + token } : {};
			const response = await axios.get(
				Constants.SERVER_URL + '/api/call/rai_voice_sample',
				{ headers, params: { voice_id }, responseType: 'blob' }
			);
			const url = URL.createObjectURL(new Blob([response.data], { type: 'audio/mpeg' }));
			if(audio_ref.current) {
				audio_ref.current.pause();
			}
			const audio = new Audio(url);
			audio_ref.current = audio;
			audio.onended = function() { set_playing(false); URL.revokeObjectURL(url); };
			audio.onerror = function() { set_playing(false); URL.revokeObjectURL(url); };
			audio.play();
		} catch(e) {
			set_playing(false);
		}
	};

	const selected_voice = voices.find(function(v) { return v.name === selected_name; });

	const handle_select = function(v) {
		set_selected_name(v.name);
		on_change('voice_id', v.voice_id);
		set_open(false);
	};

	return (
		<FormSection title="Voice">
			<div className="voice-selector-row">
				<div className="voice-dropdown" ref={dropdown_ref}>
					<div
						className="voice-dropdown-trigger"
						onClick={function() { set_open(function(prev) { return !prev; }); }}
					>
						<span>{selected_voice ? selected_voice.name : ''}</span>
						<span className="voice-dropdown-arrow">&#9660;</span>
					</div>
					{open && (
						<div className="voice-dropdown-list">
							{voices.map(function(v) {
								const is_selected = v.name === selected_name;
								return (
									<div
										key={v.name}
										className={'voice-dropdown-option' + (is_selected ? ' voice-dropdown-option-selected' : '')}
										onClick={function() { handle_select(v); }}
									>
										{v.name}
									</div>
								);
							})}
						</div>
					)}
				</div>
				<button
					disabled={!voice_id || playing}
					onClick={handle_play}
					className="voice-selector-play-btn"
				>
					{playing ? <Spinner animation="border" size="sm" /> : '▶'}
				</button>
			</div>
		</FormSection>
	);
}

export default VoiceSelector;
